module.exports = __webpack_public_path__ + "static/media/marker_animal_icon.665be94f.svg";